import SchedulesListingApp from "./SchedulesListingApp.vue";
import { vueAppWithPinia } from "../Common/vueApp";

export default vueAppWithPinia(SchedulesListingApp);
